<div class="row mt-5">
  <div class="col-12">
    <div
      class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mt-3 mb-2">
      <h3 class="fw-bold fs-6 mb-0">Google Ads Status</h3>
      <i class="bi bi-upload text-primary me-2"></i>
    </div>
    <div class="text-end">
      <button type="button" (click)="refreshActionStatus()"
              class="btn btn-primary btn-sm fw-bold">
        Refresh
      </button>
      <button type="button" (click)="createActions()" *isGranted="['ROLE_API_PARTNER_WRITE']"
              appConfirm
              class="btn btn-danger btn-sm fw-bold ms-1">Create conversion actions
      </button>
    </div>
    <div class="mb-3">
      <span class="fw-bold">Timezone: </span><span>{{ getGoogleAdsTimezoneOffset() }}</span>
    </div>
    @if (conversionActions === null) {
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    }
    @if (conversionActions !== null) {
      <table class="table">
        <thead>
        <tr>
          <th>Conversion Action Name</th>
          <th>ID</th>
          <th>Type</th>
          <th>Category</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody>
          @for (action of conversionActions; track action) {
            <tr>
              <td>{{ action.value }}</td>
              <td>{{ action.action?.id }}</td>
              @if (action.action === null) {
                <td colspan="3">
                  <span class="text-danger">⚠️ NOT CONFIGURED</span>
                </td>
              }
              @if (action.action) {
                <td>
                  @if (action.action.typeName === 'UPLOAD_CLICKS') {
                    <span
                      class="text-success">{{ action.action.typeName }}</span>
                  }
                  @if (action.action.typeName !== 'UPLOAD_CLICKS') {
                    <span
                      class="text-danger">⚠️ {{ action.action.typeName }}</span>
                  }
                </td>
                <td>
                  {{ action.action.categoryName }}
                </td>
                <td>
                  @if (action.action.statusName === 'ENABLED') {
                    <span
                      class="text-success">{{ action.action.statusName }}</span>
                  }
                  @if (action.action.statusName !== 'ENABLED') {
                    <span
                      class="text-danger">⚠️ {{ action.action.statusName }}</span>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
